<template>
  <div class="w-full">
    <PriceAndButtonCard
      source-page="payment"
      :is-loading="isRefetching"
      :price-amount="totalPrice"
      :bill-id="billId"
      :button-title="t('payment.pay')"
      @onButtonAction="$emit('onPayClick')"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed, toRef } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { PriceAndButtonCard } from '@/features/price-and-button-card';

  import { useOrderQuery } from '@/entities/order';
  import { useBill } from '@/entities/bill';

  const props = defineProps<{ orderId: string; billId: string }>();

  const orderQuery = useOrderQuery(props.orderId);
  const { bill } = useBill({ orderId: toRef(props, 'orderId') });

  const { t } = useI18n();

  const isRefetching = computed(
    () => orderQuery.isSuccess.value && orderQuery.isFetching.value,
  );

  const totalPrice = computed(() => bill.value?.amount || '');
</script>
